export { default } from './Breadcrumbs';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Breadcrumbs/index.js
// module id = 310
// module chunks = 0